import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { variableCostApiActions } from './actions';

export interface State {
  variableCosts: any[];
  loading: boolean;
  error: string;
  isUpdate: boolean;
  id: number;
}

export const initialState: State = {
  variableCosts: [],
  loading: false,
  error: '',
  isUpdate: false,
  id: 0,
};

export const variableCostFeature = createFeature({
  name: 'variableCost',
  reducer: createReducer(
    initialState,
    on(variableCostApiActions.loadVariableCost, (state) => ({
      ...state,
      loading: true,
    })),
    on(
      variableCostApiActions.loadVariableCostSuccess,
      (state, { variableCosts }) => ({
        ...state,
        variableCosts,
        loading: false,
      })
    ),
    on(variableCostApiActions.loadVariableCostFailure, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to load variable cost',
    })),
    on(variableCostApiActions.saveVariableCost, (state) => ({
      ...state,
      loading: true,
    })),
    on(variableCostApiActions.saveVariableCostSuccess, (state, { variableCost, file }) => ({
      ...state,
      variableCosts: [...state.variableCosts, variableCost],
      loading: false,
    })),
    on(variableCostApiActions.deleteVariableCost, (state) => ({
      ...state,
      loading: true,
    })),
    on(variableCostApiActions.deleteVariableCostSuccess, (state) => ({
      ...state,
      loading: false,
    })),
    on(variableCostApiActions.updateVariableCost, (state) => ({
      ...state,
      loading: true,
    })),
    on(variableCostApiActions.updateVariableCostSuccess, (state) => ({
      ...state,
      id: 0,
      isUpdate: false,
      loading: false,
    })),
    on(variableCostApiActions.setUpdate, (state, { isUpdate, id }) => ({
      ...state,
      isUpdate,
      id,
    }))
  ),
});
export const { selectLoading, selectVariableCosts, selectIsUpdate, selectId } = variableCostFeature;
export const selectVariableCostToEdit = createSelector(
  selectVariableCosts,
  selectId,
  (variableCosts, id) => {
    return variableCosts.find((variableCost) => variableCost.id === id);
  }
);